import { EnglishArabicDTO } from "bbsf-controls"
import { VariableLookupModel } from "./VariableLookupModel";
import { ParticipantModel } from './../ImpersonationRuleModels/ParticipantModel';
import { WFActivityOutcomeModel } from './WFActivityOutcomeModel';
export class WFActivityModel
{
      ID:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Description :EnglishArabicDTO=new EnglishArabicDTO();
      ActivityTypeItemID:number
      VersionID:number
      SysName :string
      OutcomeSysName:string
      TypeName :EnglishArabicDTO=new EnglishArabicDTO();
      NormalOutcomeName :EnglishArabicDTO=new EnglishArabicDTO();
      ParticipantDTO:ParticipantModel=new ParticipantModel();
      ParticipantTypeID:number
      PersmsetID:number
      NextActivityID?:number
      CanAddOutcome:boolean
      SendEmailOnTaskAssignment:boolean
      TaskName :EnglishArabicDTO=new EnglishArabicDTO();
      TaskDescription :EnglishArabicDTO=new EnglishArabicDTO();
      TaskURL:string
      TaskCorrlTypeID?:number
      VersionIDEncrypted:string
      WFIDEncryp:string
      ShowTypeInEmail:boolean
      participantPermsetsIDsString:string[]=[]
      ParticipantTypeItemIDsStringList:string[]=[]
      IsPercentageTask:boolean
      DisableOutcomeSysName:boolean
      CanCompleteFromTME:boolean
      IsEmail:boolean
      IsEditMode:boolean
      CanAddComment:boolean
      LHSVariableID?:number
      RHSVariableID?:number
      RHSTypeItemID?:number
      OperatorTypeItemID?:number
      RHSValue:string
      Outcomes:WFActivityOutcomeModel[]=[]
            

     
}
     